import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";
import {
  CreateCustomFieldRequest,
  CustomFieldRecord,
} from "@/shared/domain/customFields";

import { customFieldQueryKeys } from "./customFieldQueryKeys";

/**
 * Creates a custom-field definition in the current org. On success it
 * invalidates the cached lists so the new field appears; `useCustomFields`
 * then polls it Creating -> Ready without a manual refresh.
 */
export function useCreateCustomField() {
  const { customFieldService } = useDomainServices();
  const queryClient = useQueryClient();
  const orgId = useCurrentOrgId();

  return useMutation<CustomFieldRecord, Error, CreateCustomFieldRequest>({
    mutationFn: (request) =>
      customFieldService.createCustomField(request, { orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: customFieldQueryKeys.lists(),
      });
    },
  });
}
